import { useNavigate } from "react-router-dom";
import { useTranslation } from "../i18n";
import "../styles/NotFound.css";

const NotFound = ({ setShowForm }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSubscribe = () => {
    navigate("/");
    if (typeof setShowForm === "function") setShowForm(true);
  };

  return (
    <div className="notfound-wrapper">
      <div className="notfound-noise" aria-hidden="true" />

      <div className="notfound-content">
        <img
          src="/files/images/mxd_logo.svg"
          alt="Mixordia"
          className="notfound-logo"
        />

        <div className="notfound-code">404</div>

        <h1 className="notfound-title">{t("notfound.title")}</h1>
        <p className="notfound-message">{t("notfound.message")}</p>

        <div className="notfound-ctas">
          <button className="notfound-btn notfound-btn--primary" onClick={handleSubscribe}>
            {t("notfound.ctaSubscribe")}
          </button>
          <button className="notfound-btn" onClick={() => navigate("/")}>
            {t("notfound.ctaHome")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
